export const completeTagRegex = /{{slip_completed_(\d+)}}/g
export const moreTagRegex = /{{slip_completed_more_than_(\d+)}}/g

export const defaultCompleteTag = '{{slip_completed_n}}'
export const defaultMoreTag = '{{slip_completed_more_than_n}}'

export const checkIsTagVerifySlip = tag => {
  if (!tag) return false
  return Boolean(tag.match(completeTagRegex) || tag.match(moreTagRegex))
}

export const checkIsTagVerifySlipComplete = tag => {
  if (!tag) return false
  return Boolean(tag.match(completeTagRegex))
}

export const checkIsTagVerifySlipMore = tag => {
  if (!tag) return false
  return Boolean(tag.match(moreTagRegex))
}

export const checkIsDefaultTagVerifySlip = tag => {
  if (!tag) return false
  return Boolean(tag === defaultCompleteTag || tag === defaultMoreTag)
}

export const getTagWithDefaultVerifySlipTag = tags => {
  if (!tags) return []
  return ['{{slip_completed_n}}', '{{slip_completed_more_than_n}}', ...tags]
}

export const checkVerifySlipTagType = tag => {
  if (!tag) return ''

  if (tag.includes('slip_completed_more_than')) {
    return 'more'
  } else if (tag.includes('slip_completed')) {
    return 'complete'
  } else {
    return ''
  }
}

export const replaceTags = tag => {
  if (!tag) return ''

  if (tag === defaultCompleteTag) {
    return 'ตรวจสลิป n ครั้ง'
  } else if (tag === defaultMoreTag) {
    return 'ตรวจสลิปมากกว่า n ครั้ง'
  } else if (tag.match(completeTagRegex)) {
    return tag.replace(completeTagRegex, (match, n) => {
      return `ตรวจสลิป ${n} ครั้ง`
    })
  } else if (tag.match(moreTagRegex)) {
    return tag.replace(moreTagRegex, (match, n) => {
      return `ตรวจสลิปมากกว่า ${n} ครั้ง`
    })
  } else {
    return tag
  }
}

export const replaceTagString = tag => {
  if (!tag) return ''
  return tag
    .replace(completeTagRegex, (match, n) => `ตรวจสลิป ${n} ครั้ง`)
    .replace(moreTagRegex, (match, n) => `ตรวจสลิปมากกว่า ${n} ครั้ง`)
}

export const getTagValue = tag => {
  if (!tag) return ''

  if (tag.match(completeTagRegex)) {
    return tag.replace(completeTagRegex, (match, n) => {
      return n
    })
  } else if (tag.match(moreTagRegex)) {
    return tag.replace(moreTagRegex, (match, n) => {
      return n
    })
  } else {
    return null
  }
}

export const getRealTag = tags => {
  if (!tags) return null

  const newTags = tags.split(',')
  let tagValue = {
    items: [],
    complete: null,
    moreThan: null
  }

  for (let i = 0; i < newTags.length; i++) {
    const tag = newTags[i]
    if (tag.match(completeTagRegex)) {
      tagValue.complete = getTagValue(tag)
    } else if (tag.match(moreTagRegex)) {
      tagValue.moreThan = getTagValue(tag)
    } else {
      tagValue.items.push(tag)
    }
  }

  return tagValue
}

export const setTagValue = (type, value) => {
  if (!type || value === null || value === undefined) return ''

  if (type === 'complete') {
    return defaultCompleteTag.replace('_n', `_${value}`)
  } else if (type === 'more') {
    return defaultMoreTag.replace('_n', `_${value}`)
  }
}

export const getTagPayload = (include, exclude) => {
  const tagIncludes = getRealTag(include || '')
  const tagIncludeOption = {}

  if (tagIncludes && tagIncludes.complete) {
    Object.assign(tagIncludeOption, { total_completed_verify_slip: Number(tagIncludes.complete) })
  }

  if (tagIncludes && tagIncludes.moreThan) {
    Object.assign(tagIncludeOption, { total_completed_verify_slip_more_than: Number(tagIncludes.moreThan) })
  }

  const tagExcludes = getRealTag(exclude || '')
  const tagExcludeOption = {}

  if (tagExcludes && tagExcludes.complete) {
    Object.assign(tagExcludeOption, { exclude_total_completed_verify_slip: Number(tagExcludes.complete) })
  }

  if (tagExcludes && tagExcludes.moreThan) {
    Object.assign(tagExcludeOption, { exclude_total_completed_verify_slip_more_than: Number(tagExcludes.moreThan) })
  }

  return {tagIncludes, tagIncludeOption, tagExcludes, tagExcludeOption}
}



// WEBPACK FOOTER //
// ./src/utils/tags.js